import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ReactS3Uploader from 'react-s3-uploader';
import './UploadPhoto.scss';

const FILE_SIZE = 5000000; // 5mb

class UploadImage extends React.Component {
  constructor (props, context) {
    super(props, context);

    this.HandleUpload = this.HandleUpload.bind(this);
    this.HandlePreProcess = this.HandlePreProcess.bind(this);
    this.HandleError = this.HandleError.bind(this);
    this.onProgress = this.onProgress.bind(this);

    this.state = {
      file: '',
      imagePreviewURL: '',
      error: '',
      loading: false,
      percent: 0
    };

    if (props.defaultValue) {
      this.state = {
        imagePreviewURL: IMAGECACHELINK + '/' + IMAGESTAGE + '/600x600/' + props.defaultValue, // eslint-disable-line no-undef
        error: '',
        file: props.defaultValue,
        loading: false,
        percent: 0
      };
    }
  }

  HandlePreProcess (file, next) {
    if (file) {
      let isValidFormat = /\.jpe?g$/i.test(file.name) || /\.png$/i.test(file.name);

      if (isValidFormat) {
        if (file.size <= FILE_SIZE) {
          next(file);
        } else {
          this.setState({ error: 'This file was too large!' });
        }
      } else {
        this.setState({ error: 'This is the incorrect file type.' });
      }
    }
  }

  HandleUpload (event, file) {
    if (event) {
      if (file) {
        if (this.props.onChange !== undefined) {
          this.props.onChange({ // Somewhat fake the standard onChange Event
            target: {
              value: event.PhotoID
            }
          });
        }

        if (this.props.onUpload !== undefined) {
          this.props.onUpload({ // Somewhat fake the standard onChange Event
            target: {
              value: event.PhotoID
            }
          });
        }

        window.setTimeout(function () {
          this.setState({
            imagePreviewURL: IMAGECACHELINK + '/' + IMAGESTAGE + '/600x600/' + event.PhotoID, // eslint-disable-line no-undef
            error: '',
            file: event.PhotoID,
            loading: false,
            percent: 0
          });
        }.bind(this), 1000);
      };
    }
  }

  HandleError (message) {
    this.setState({
      imagePreviewURL: '',
      error: message,
      file: '',
      loading: false,
      percent: 0
    });
  }

  onProgress (percent, message) {
    this.setState({
      loading: true,
      percent: percent
    });
  }

  render () {
    return (
      <div className='UploadPhoto'>
        <ReactS3Uploader
          onFinish={this.HandleUpload}
          preprocess={this.HandlePreProcess}
          id={this.props.name + '__Display'}
          onProgress={this.onProgress}
          onError={this.HandleError}
          className='UploadPhoto__Input'
          signingUrl={'/' + IMAGESTAGE + '/InitUpload'} // eslint-disable-line no-undef
          signingUrlMethod='GET'
          uploadRequestHeaders={{}} // This is necessary due to a bug in AWS
          server={LAMBDALINK} // eslint-disable-line no-undef
        />
        <div className='UploadPhoto__Container'>
          <input readOnly className='UploadPhoto__FinalIDInput' type='text' name={this.props.name} value={this.state.file} />
          <div className='UploadPhoto__ImageContainer'>
            <label htmlFor={this.props.name + '__Display'} className='UploadPhoto__Touch' />
            <img src={this.state.imagePreviewURL} className={classNames({
              'UploadPhoto__ImagePreview': true,
              'UploadPhoto__ImagePreview--inactive': (this.state.imagePreviewURL === '')
            })} />
          </div>
          <span className='UploadPhoto__ErrorMessage'>{this.state.error}</span>
          {(this.props.ButtonText !== undefined)
            ? <label className='UploadPhoto__BrowseButton' htmlFor={this.props.name + '__Display'}>
              {(this.state.loading === false) ? this.props.ButtonText : ('Uploading ' + this.state.percent + '%')}
            </label>
            : null}
        </div>
      </div>
    );
  };
}

UploadImage.propTypes = {
  name: PropTypes.string,
  ButtonText: PropTypes.string,
  onChange: PropTypes.func,
  onUpload: PropTypes.func,
  defaultValue: PropTypes.string
};

export default UploadImage;



// WEBPACK FOOTER //
// ./src/components/Form/UploadPhoto/index.js